import { MERCH_STAFF_EDITOR_ROLE, type MeResponse } from "@seagames/contracts";

/**
 * Who sees the Merchandising pages. NONE of this decides anything: every
 * `/merch` route is fenced by the API on the ACTIVE role plus the SQL rule
 * (`merchAccessSql`: SUPER_ADMIN, or an ADMIN on the merch staff list). The
 * GMS reads that verdict from `/auth/me.merch_access` and never re-derives
 * it — it only picks which pages and buttons to draw, so nobody clicks into
 * a page of 403s.
 *
 * `merch_access` is optional in the type so the nav's narrower session
 * fixtures (active role + group) read as "no access".
 */
type Session = Pick<MeResponse, "active_role"> & Partial<Pick<MeResponse, "merch_access">>;

/** The nav entry and the route guard. */
export const canSeeMerch = (me: Session): boolean => me.merch_access === true;

/** The Staff tab: only SUPER_ADMIN edits the merch staff list. */
export const canEditMerchStaff = (me: Session): boolean => canSeeMerch(me) && me.active_role === MERCH_STAFF_EDITOR_ROLE;
